// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"_3XQyJhkGh6WHcdy3Q9d8r2","icon":"GuzysNKpUF3EfHGKVGt9_","active":"nVtMhmsDhgcnRQ3C42fMT"};